import * as React from "react";
import classnames from "classnames";
/* empty css           */
class Image extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.state = {
      q: this.props.lazyLoadingOptions && this.props.lazyLoadingOptions.q || "",
      auto: this.props.lazyLoadingOptions && this.props.lazyLoadingOptions.auto || ""
    };
    this.renderImage = (lazyLoadingUrl, { lazyLoadingOptions, cover, alt, ...rest }) => /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "image__background-image",
        role: "img",
        "aria-label": Boolean(rest["aria-hidden"]) ? void 0 : alt,
        "aria-hidden": rest["aria-hidden"],
        style: {
          backgroundImage: `url('${lazyLoadingUrl}')`,
          backgroundSize: `${cover ? "cover" : "contain"}`
        }
      }
    );
  }
  componentDidMount() {
    const { lazyLoadingOptions } = this.props;
    if (lazyLoadingOptions) {
      this.setState({
        q: "",
        auto: ""
      });
    }
  }
  render() {
    const { url, onClick, className, children } = this.props;
    const { q, auto } = this.state;
    const urlOptionQuality = q && `&q=${q}`;
    const urlOptionAutomatic = auto && `&auto=${auto}`;
    const lazyLoadingUrl = url + urlOptionQuality + urlOptionAutomatic;
    return onClick ? /* @__PURE__ */ React.createElement("button", { className: classnames("image", className), onClick }, this.renderImage(lazyLoadingUrl, this.props)) : /* @__PURE__ */ React.createElement("div", { className: classnames("image", className) }, this.renderImage(lazyLoadingUrl, this.props), children);
  }
}
export {
  Image as default
};
//# sourceMappingURL=Image.js.map
